import { Component, EventEmitter, Output, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl, ValidationErrors } from '@angular/forms';
import { DataserviceService } from 'src/app/dataservice.service';
import { NzMessageService } from 'ng-zorro-antd/message';

export function afterTodayValidator(control: AbstractControl): ValidationErrors | null {
  if (!control.value) return null;

  const [year, month, day] = control.value.split('-').map(Number);
  const selectedDate = new Date(year, month - 1, day);
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  return selectedDate < today ? { afterOrEqualToday: true } : null;
}



@Component({
  selector: 'app-processing-fee',
  templateUrl: './processing-fee.component.html',
  styleUrl: './processing-fee.component.css'
})
export class ProcessingFeeComponent {
  @Input() fullData: any;
  @Output() send = new EventEmitter<any>();

  pFeeForm: FormGroup;
  processingFees = [
    {
      title: '$49.99',
      value: '$49.99'
    },
    {
      title: '$24.99',
      value: '$24.99'
    },
    {
      title: '$0.00',
      value: '$0.00'
    }
  ];
  currentUser: any;
  offers: any;
  loadingId: any;
  submitting = false;

  constructor(
    private fb: FormBuilder,
    private message: NzMessageService,
    private data: DataserviceService
  ) {

    this.pFeeForm = this.fb.group({
      processingFee: ['', [Validators.required]],
      processingFeeDate: ['', [afterTodayValidator]],
      promoCode: ['', []],
      autopay: [false],
      paperless: [false],
      pin: ['', Validators.required],
      pinHint: ['', Validators.required],
      id: [null, []],
    })

    this.pFeeForm.get('processingFee')?.valueChanges.subscribe(val => {
      const control = this.pFeeForm.get('processingFeeDate');

      const validators = [afterTodayValidator];
    
      if (val !== '$0.00') {
        validators.push(Validators.required);
      }
    
      control?.setValidators(validators);
      control?.updateValueAndValidity({ onlySelf: true, emitEvent: false });
    });

    this.currentUser = JSON.parse(localStorage.getItem('user') || '{}');
  }

  ngOnInit() {
    console.log(this.fullData)
    this.getOffers();

    if(this.fullData?.processingFee) {

      this.pFeeForm.patchValue({
        processingFee: this.fullData?.processingFee?.pfeeInfo?.processingFee,
        processingFeeDate: this.fullData?.processingFee?.pfeeInfo?.processingFeeDate,
        promoCode: this.fullData?.processingFee?.pfeeInfo.promoCode,
        autopay: this.fullData?.processingFee?.pfeeInfo.autopay,
        paperless: this.fullData?.processingFee?.pfeeInfo.paperless,
        pin: this.fullData?.processingFee?.pfeeInfo.pin,
        pinHint: this.fullData?.processingFee?.pfeeInfo.pinHint,
        id: this.fullData?.processingFee?.pfeeInfo.pinHint
      })
    }

    if (this.fullData?.preQual) {
      ['promoCode'].forEach(field => {
        this.pFeeForm.get(field)?.disable({ emitEvent: false });
      });
    } else {
      ['promoCode'].forEach(field => {
        this.pFeeForm.get(field)?.enable({ emitEvent: false });
      });
    }
  }

  getOffers() {
    this.loadingId = this.message.loading('Getting offers...', { nzDuration: 0 }).messageId;
    this.data.getData('dish/dishOffers')
      .subscribe((r:any) => {
        this.offers = r.data || r;
        this.message.remove(this.loadingId)
    }, e => {
      console.log('error dish offers');
      console.log(e);
      this.message.remove(this.loadingId)
    })
  }

  submitForm() { 
    if (this.submitting) {
      return;
    }
    this.submitting = true;
    this.message.remove(this.loadingId)
    this.loadingId = this.message.loading('Updating work order...', { nzDuration: 0 }).messageId;
    this.data.postDataNoBodyDotBody(
      {
        woId: this.fullData.woId,
        id: this.fullData.customerId,
        generic: {
          processingFeeInfo: this.pFeeForm.value
        }
      },
      'work-order/update-generic'
    ).subscribe((r: any) => {
      this.message.remove(this.loadingId)
      this.createPf();
    }, e => {
      console.log('e');
      console.log(e);
      this.message.remove(this.loadingId)
      this.submitting = false;
    })
  }

  createPf() {

    let obj = {
      status: 'pending',
      customer_id: this.fullData.customerId,
      user_id: this.currentUser?.id,
      provider: 'processing fee',
      generic: this.pFeeForm.value,
      id: this.pFeeForm.value.id
    }

    if (obj.id) {
      this.message.remove(this.loadingId)
      this.loadingId = this.message.loading('Updating processing fee...', { nzDuration: 0 }).messageId;

      this.data.postDataNoBodyDotBody(obj, 'work-order/update')
        .subscribe((r: any) => {
          this.message.remove(this.loadingId)
          this.send.emit({ pfeeInfo: this.pFeeForm.value });
          this.submitting = false;
        }, e => {
          console.error(e);
          this.message.remove(this.loadingId)
          this.submitting = false;
        });

    } else if(this.pFeeForm.get('processingFee')?.value != '$0.00' && !obj.id) {
      this.message.remove(this.loadingId)
      this.loadingId = this.message.loading('Creating processing fee...', { nzDuration: 0 }).messageId;
      this.data.postDataNoBodyDotBody(obj, 'work-order/create').subscribe((r: any) => {

        const payload = {
          ...this.pFeeForm.value,
          id: r?.data?.id
        };
        this.message.remove(this.loadingId)
        this.send.emit({ pfeeInfo: payload });
        this.submitting = false;

      }, e => {
        console.error(e);
        this.message.remove(this.loadingId)
        alert('Failed to create processing fee')
        this.submitting = false;
      });
    }else {

      const payload = {
        ...this.pFeeForm.value,
        id: null
      }
      this.send.emit({ pfeeInfo: payload });
      this.submitting = false;

    }

  }
}
